import Dexie from 'dexie';

const db = new Dexie('carcheck.referential');
db.version(1).stores({
  referential: ', referentialId',
  // dashboard : ''
});

export default db;
